import { EthereumStakingOrderInfo } from '#/data/react-query/queries/order-list';
import { Translation } from 'intl-lib';

interface Props {
  item: EthereumStakingOrderInfo;
}

export function OrderDisplayName({ item }: Props) {
  return (
    <Translation
      path="global.modules.order_name"
      params={{
        name: item.paramsSig.slice(-6),
      }}
    />
  );
}
